import { cn } from '@apps/web/lib/utils';

function TeachPhoebeSproutIcon({ className }: { readonly className?: string }) {
    return (
        <svg
            className={className}
            viewBox="0 0 24 24"
            fill="none"
            stroke="currentColor"
            strokeWidth={2}
            strokeLinecap="round"
            strokeLinejoin="round"
            aria-hidden={true}
        >
            <path
                className="teach-phoebe-sprout-ground"
                pathLength={100}
                d="M5 21h14"
            />
            <path
                className="teach-phoebe-sprout-stem"
                pathLength={100}
                d="M14 9.536V7a4 4 0 0 1 4-4h1.5a.5.5 0 0 1 .5.5V5a4 4 0 0 1-4 4 4 4 0 0 0-4 4c0 2 1 3 1 5a5 5 0 0 1-1 3"
            />
            <path
                className="teach-phoebe-sprout-leaf"
                pathLength={100}
                d="M4 9a5 5 0 0 1 8 4 5 5 0 0 1-8-4"
            />
        </svg>
    );
}

export function TeachPhoebeWordmark({
    className,
}: {
    readonly className?: string;
}) {
    return (
        <div
            className={cn(
                'text-training-accent-strong flex items-center gap-1.5 pr-6',
                className,
            )}
        >
            <TeachPhoebeSproutIcon className="teach-phoebe-sprout text-training-accent h-4 w-4 shrink-0 overflow-visible" />
            <span className="text-sm font-semibold">Teach Phoebe</span>
        </div>
    );
}
